import { useDispatch } from 'react-redux'
import cx from 'classnames'

import Button from 'common/components/button/Button'
import Tooltip from 'common/components/Tooltip'
import { useAppSelector } from 'common/hooks/redux'
import { ReactComponent as Eye } from 'common/icons/eye/default.svg'
import { ReactComponent as EyeNo } from 'common/icons/eyeNo/default.svg'
import { hidePreview, showPreview } from 'features/futurama/store/contentSlice'

import { getContentHasVariants } from '../../helpers'
import { useContent, useIsMultistep } from '../../hooks'

import ExportMenuButton from './headerActionButtons/ExportMenuButton'

const HeaderActions = () => {
  const { content } = useContent()
  const selectedElementId = useAppSelector(
    (state) => state.content.selectedElementId
  )
  const dispatch = useDispatch()
  const { isMultistep } = useIsMultistep()

  const isPreviewVisible = useAppSelector(
    (state) => state.content.isPreviewVisible
  )

  return (
    <div className="flex items-center">
      {isMultistep && (
        <>
          <Button
            className={cx('text-coolGray-400', {
              hidden: isPreviewVisible === false,
              'hidden lg:block': isPreviewVisible === undefined,
            })}
            prefixIcon={
              <Tooltip overlay="Hide preview">
                <EyeNo width={24} height={24} />
              </Tooltip>
            }
            onClick={() => dispatch(hidePreview())}
          />
          <Button
            className={cx('text-coolGray-400', {
              hidden: isPreviewVisible === true,
              'lg:hidden': isPreviewVisible === undefined,
            })}
            prefixIcon={
              <Tooltip overlay="Show preview">
                <Eye width={24} height={24} />
              </Tooltip>
            }
            onClick={() => dispatch(showPreview())}
          />
        </>
      )}
      {selectedElementId && getContentHasVariants(content) && (
        <ExportMenuButton />
      )}
    </div>
  )
}

export default HeaderActions
